import {
  OwlClient,
  BrowserWebClientStorage,
  PigeonClient,
} from '@insurgrid/common';

// TrackingPixel moved to ../components/TrackingPixel — it uses useSearchParams,
// and Next 14 rejects client hooks in a module that server components import
// (app/[agentSlug]/page.tsx imports owlClient from here).

export const getPigeonClient = () =>
  new PigeonClient(
    process.env.NEXT_PUBLIC_PIGEON_ROOT_URL as string,
    new BrowserWebClientStorage(),
  );

export const pigeonClient = new PigeonClient(
  process.env.NEXT_PUBLIC_PIGEON_ROOT_URL as string,
  new BrowserWebClientStorage(),
);

export const owlClient = new OwlClient(
  process.env.NEXT_PUBLIC_OWL_API_ROOT_URL as string,
  new BrowserWebClientStorage(),
);
